var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "70px",
    height: "70px",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9c300;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.3,160.1a45.3,45.3,0,0,1,45.3-45.3H377v54.4a45.2,45.2,0,0,1-45.3,45.2H277.3Z",
    transform: "translate(-177 -114.8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177,260.5a45.2,45.2,0,0,1,45.2-45.3h54.4v54.3a45.3,45.3,0,0,1-45.3,45.3H177Z",
    transform: "translate(-177 -114.8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377,260.5a45.3,45.3,0,0,0-45.3-45.3H277.3v54.3a45.3,45.3,0,0,0,45.3,45.3H377Z",
    transform: "translate(-177 -114.8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.6,160.1a45.3,45.3,0,0,0-45.3-45.3H177v54.4a45.2,45.2,0,0,0,45.2,45.2h54.4Z",
    transform: "translate(-177 -114.8)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeLogo);
export default __webpack_public_path__ + "static/media/largeLogo.94ace25c0cdc824700cf6f5a2eb1cac0.svg";
export { ForwardRef as ReactComponent };